<div class="d-flex">
  <app-mobile-header-main (titleClicked)="openTaxonomyMenu = $event" mainTitle="{{ 'documents.folders' | translate }}" menulink="/menu/pastas"></app-mobile-header-main>
  <div class="taxonomy-overlay" [class.taxonomy-overlay-active]="openTaxonomyMenu" (click)="openTaxonomyMenu = false"></div>
  @if (urlParamsService.params.sidebar) {
    <app-taxonomy mainTitle="{{ 'menu.folders' | translate }}" allowSearch [(isSearchOpen)]="isSearchOpen" (isSearchOpenChange)="toggleSearch($event)" [class.isMenuMobileOpen]="openTaxonomyMenu">
      <app-documents-taxonomy
        [isSearchOpen]="isSearchOpen"
        (sortingChange)="loadFolders({ page: 1, search: searchQuery })"
        (newFolderButtonClick)="openCreateFolderModal()"
        [listPath]="'default'"
      ></app-documents-taxonomy>
    </app-taxonomy>
  }
</div>

<div class="d-flex flex-column w-100">
  @if (isSearchOpen) {
    <app-documents-search
      [isFoldersSearch]="true"
      [(search)]="searchQuery"
      (searchChange)="pageNumber = 1; loadFolders({ page: 1, search: $event })"
      (closeClick)="isSearchOpen = false; toggleSearch(isSearchOpen)"
      @slideDownUpTrigger
    ></app-documents-search>
  }

  <div class="documents">
    <div class="documents__header justify-content-start">
      @if ((isSearchOpen && searchQuery) || mobileSearch) {
        <h2 class="documents__title">{{ 'documents.searchResults' | translate }}</h2>
      } @else {
        <h2 class="documents__title">
          {{ 'menu.folders' | translate }}
          @if (currentUser?.organization?.name) {
            <span class="highlight">{{ ('shared.in' | translate) + ' ' + currentUser?.organization?.name }}</span>
          }
        </h2>

        @if (!isMobile) {
          <button class="btn-M btn-text icon-start d-flex ml-auto mb-2" (click)="openCreateFolderModal()">
            <i class="far fa-folder-plus"></i>
            {{ 'menu.newFolder' | translate }}
          </button>
        }
      }
      <app-search [(query)]="mobileSearch" (queryChange)="pageNumber = 1; loadFolders({ page: 1, search: { search: $event } })"></app-search>
    </div>

    @if (folders && folders.length === 0 && !searchQuery && !mobileSearch) {
      <div class="documents-empty">
        <img src="/assets/alerts/confirmation-2.svg" alt="" />
        <p class="documents-empty__title">{{ 'documents.noFolders' | translate }}</p>

        <button type="button" (click)="openCreateFolderModal()" class="btn-M btn-filled">
          {{ 'documents.createAFolder' | translate }}
        </button>
      </div>
    } @else if (!isLoading && folders && folders.length === 0 && (searchQuery || mobileSearch)) {
      <div class="documents-filtered-empty">
        <div class="documents-filtered-empty_title">{{ 'settings.nothingHere' | translate }}</div>
        <div class="documents-filtered-empty_text">
          <span>{{ 'documents.noDocumentsMatchingFilter' | translate }}</span>
        </div>
        <button type="button" class="default-button" (click)="clearFilters()">{{ 'documents.clearFilters' | translate }}</button>
      </div>
    }

    <app-folders-list-boxes
      [folders]="folders"
      [hidePagination]="isLoading || isLastPage"
      [memberId]="memberId"
      (loadPageClick)="loadFolders({ page: pageNumber + 1, search: searchQuery })"
      (updateClick)="openUpdateFolderModal($event)"
      (shareClick)="openShareFolderModal($event)"
      (folderClick)="openFoldersModal($event)"
      (deleteClick)="deleteFolder($event)"
    >
    </app-folders-list-boxes>
  </div>
</div>
